<div [class]="'relative group ' + (fullWidth ? 'block' : 'inline-block')">
  <button [class]="computedClasses" [disabled]="disabled || loading" [type]="type" [attr.aria-label]="ariaLabel || null" (click)="handleRipple($event)"
    [ngStyle]="computedStyles" [class.use-custom-color]="isCustomColor" [attr.data-color]="color">
    <!-- Loading spinner -->
    @if (loading) {
    <div class="mr-2 relative">
      <div class="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent opacity-60"></div>
      <div
        class="absolute inset-0 h-4 w-4 animate-spin rounded-full border border-current border-t-transparent animate-reverse">
      </div>
    </div>
    }

    <!-- Left icon slot -->
    @if (iconLeft && !loading) {
    <span class="mr-2 flex items-center justify-center leading-none">
      <ng-content select="[slot=icon-left]"></ng-content>
    </span>
    }

    <!-- Main content -->
    <span class="relative z-10 flex items-center justify-center leading-none">
      <ng-content></ng-content>
    </span>

    <!-- Right icon slot -->
    @if (iconRight) {
    <span class="ml-2 flex items-center justify-center leading-none">
      <ng-content select="[slot=icon-right]"></ng-content>
    </span>
    }

    <!-- Glassmorphism shine effect -->
    <div class="absolute inset-0 pointer-events-none opacity-0 hover:opacity-20 transition-opacity duration-500">
      <div class="absolute inset-0 bg-linear-to-r from-transparent via-white to-transparent
                      transform -skew-x-12 -translate-x-full group-hover:translate-x-full
                      transition-transform duration-1000 ease-out"></div>
    </div>

    <!-- Ripple effect container -->
    <div class="absolute inset-0 pointer-events-none overflow-hidden rounded-xl">
      <div class="ripple-container"></div>
    </div>
  </button>

  <!-- Tooltip -->
  @if (tooltip) {
  <div class="absolute z-50 px-2 py-1 text-sm font-medium text-white bg-gray-900 rounded-md shadow-lg
               opacity-0 invisible transition-all duration-200 ease-in-out
               group-hover:opacity-100 group-hover:visible
               pointer-events-none whitespace-nowrap backdrop-blur-sm
               dark:bg-gray-800 dark:text-gray-200" [class]="getTooltipPositionClasses()">
    {{ tooltip }}
    <!-- Tooltip arrow -->
    <div class="absolute w-2 h-2 bg-gray-900 transform rotate-45 dark:bg-gray-800" [class]="getTooltipArrowClasses()">
    </div>
  </div>
  }
</div>
